import { render, staticRenderFns } from "./ProductCardPlaceholder.vue?vue&type=template&id=eab81aa2&scoped=true&"
import script from "./ProductCardPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ProductCardPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPlaceholder.vue?vue&type=style&index=0&id=eab81aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab81aa2",
  null
  
)

export default component.exports